import styled from 'styled-components';
import { TrimCarouselStyled } from '../TrimCarouselStyled';
import { breakpoints } from '../../../styles/AC/theme';
import { rem } from 'polished';

export const TrimCarouselStyledDS = styled(TrimCarouselStyled)`
    @media (min-width: ${breakpoints.sm}px) {
        .image-item {
            width: fit-content !important;
            min-width: ${rem('426px')};
            padding: unset;
        }
    }

    .trimCarousel {
        .stockModelCard-header--heading {
            white-space: nowrap;
        }
    }

    .trimItemWrap {
        padding: ${rem('1px')};

        & > div > div {
            padding: ${rem('18px')};
            align-items: flex-end;
            @media (max-width: ${breakpoints.md}px) {
                margin: auto;
            }
        }
    }

    .react-multi-carousel-list {
        padding-top: 40px;

        @media (min-width: ${breakpoints.sm}px) {
            padding-top: 60px;
        }

        @media (min-width: ${breakpoints.lg}px) {
            padding-top: unset;
        }
    }

    .carouselArrows-wrapper__btnsSection {
        .arrowBtn {
            background: ${({ theme }) => theme.colors.coffee};
            border: 1px solid ${({ theme }) => theme.colors.coffee};

            @media (min-width: ${breakpoints.md}px) {
                background: transparent;
                border: 1px solid ${({ theme }) => theme.colors.black3};
            }

            svg path {
                fill: ${({ theme }) => theme.colors.white};
                stroke: ${({ theme }) => theme.colors.white};

                @media (min-width: ${breakpoints.md}px) {
                    fill: ${({ theme }) => theme.colors.black3};
                    stroke: ${({ theme }) => theme.colors.black3};
                }
            }
        }

        .arrowBtn--disabled {
            border: 1px solid ${({ theme }) => theme.colors.coffee};
            opacity: 0.4;

            svg path {
                fill: ${({ theme }) => theme.colors.grey3};
            }
        }
    }

    .currentSlideSection {
        font-size: ${rem(20)};
        @media (max-width: ${breakpoints.md}px) {
            font-size: ${rem(16)};
        }
    }
`;
